<template>
  <div class="disbursement__single outer-container">
    <div class="panel">
      <div class="panel__header">
        <disburse-options></disburse-options>
      </div>
      <div class="panel__content panel__content--grey panel__content--heavy-padded">
        <!--single transfer-->
        <form action="" class="form disburse-form disburse-form__single">
          <div class="form__item">
            <label for="disburseSource" class="form__label--span form--left">Send <span> from</span></label>
            <div class="select form--right">
              <select name="disburse-source" id="disburseSource" class="select__input">
                <option value="USD wallet">Wallet - USD ($328,000,000)</option>
                <option value="USD wallet">Wallet - USD ($328,000,000)</option>
                <option value="USD wallet">Wallet - USD ($328,000,000)</option>
                <option value="USD wallet">Wallet - USD ($328,000,000)</option>
              </select>
              <div class="select__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>
              </div>
            </div>
          </div>
          
          <!--disburse amount-->
          <div class="form__item">
            <label for="disburseAmount" class="form__label--span form--left">Payment <span> amount</span></label>
            <div class="form--right">
              <div class="select currency-select">
                <select name="disburse-amount" id="disburseAmount" class="select__input">
                  <option value="USD wallet">USD ($)</option>
                  <option value="USD wallet">KES (Sh)</option>
                  <option value="USD wallet">GHC (GH)</option>
                  <option value="USD wallet">NGN (#)</option>
                </select>
                <div class="select__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>
                </div>
              </div>
              <div class="amount-input">
                <input type="text" class="form__input" placeholder="">
              </div>
            </div>
          
          </div>
          
          <!--payment reference-->
          <div class="form__item">
            <label for="disburseReference" class="form__label--span form--left">Payment <span> reference</span></label>
            <div class="amount-input form--right">
              <input type="text" class="form__input" id="disburseReference"  placeholder="Paying my debts">
            </div>
          </div>
          
          <!--schedule time-->
          <div class="form__item">
            <label for="disburseAmount" class="form__label--span form--left">Repeat <span> every</span></label>
            <div class="form--right">
              <div class="select  disburse__month-schedule">
                <select name="disburse__month-schedule" id="disburseScheduleMonth" class="select__input">
                  <option value="month">Month</option>
                  <option value="week">Week</option>
                  <option value="year">Year</option>
                </select>
                <div class="select__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>
                </div>
              </div>
              <div class="form__input form__input--fake">On the</div>
              <div class="select disburse__day-schedule">
                <select name="disburse__day-schedule" id="disburseScheduleDay" class="select__input">
                  <option value="1st">1st</option>
                  <option value="2nd">2nd</option>
                  <option value="3rd">3rd</option>
                  <option value="4th">4th</option>
                </select>
                <div class="select__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>
                </div>
              </div>
            </div>
  
          </div>
          
          <!--payment beneficiary type-->
          <div class="form__item">
            <label class="form__label--span form--left">Send money <span> to</span></label>
            <div class="form--right form__radios">
              <div class="radio__item radio-container radio__item__flex">
                <input type="radio" class="radio__item__input" name="beneficiary-type" id="disburseBeneficiaryNew"  placeholder="">
                <label for="disburseBeneficiaryNew" class="radio__item__label">New Account</label>
              </div>
              <div class="radio__item radio-container radio__item__flex">
                <input type="radio" class="radio__item__input" name="beneficiary-type" id="disburseBeneficiarySaved"  placeholder="" checked>
                <label for="disburseBeneficiarySaved" class="radio__item__label">Saved Recipient</label>
              </div>
            </div>
          </div>
          
          <!--choose recipients-->
          <div class="form__item">
            <label class="form__label--span form--left">Recipient</label>
            <div class="recipient-list form--right">
              <input id="recipientList" type="text" class="form__input" placeholder="Nosa Balogun">
              <span class="search__icon search__icon__right">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="#919EAB" fill-rule="evenodd" d="M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.707 4.293l-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414"/>
                </svg>

              </span>
            </div>
          </div>
          
          <div class="form__item disburse-form__submit">
            <button class="btn btn--primary btn--block">SEND NOW</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import DisburseOptions from '@/components/partials/DisburseOptions'
  
  export default {
    
    data() {
      return {
        showModal: false,
      }
    },
    components:{
      'disburse-options': DisburseOptions
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/disbursement/ScheduledTransfers.vue